/**
 * The inline "re-reading the listing" line, shared by both GBP tabs.
 *
 * A re-check keeps the previous result on screen, so the only signal used to
 * be a spinning icon inside the button — for a read that takes 10 to 35
 * seconds, and up to 38 on the largest listing. An operator who has just
 * pressed it and sees the OLD numbers still sitting there has no way to know
 * whether anything is happening (2026-09-23).
 *
 * Deliberately a line, not a takeover: the stale numbers are still the best
 * information available until the new ones land, so they stay. What was
 * missing was an explanation beside them.
 *
 * Same staged copy as the first-load wait, so the wording never contradicts
 * itself between the two.
 */
import { Loader2 } from "lucide-react";

import { gbpAuditLoadingStage } from "./gbpAuditLoadingCopy";

interface Props {
	elapsedSeconds: number;
	testId?: string;
}

export default function GbpRecheckBanner({
	elapsedSeconds,
	testId = "gbp-recheck-banner",
}: Props) {
	const stage = gbpAuditLoadingStage(elapsedSeconds);
	return (
		<div
			className="mt-1 flex items-center gap-2"
			role="status"
			aria-live="polite"
			data-testid={testId}
		>
			<Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-coral" />
			<span
				className={
					stage.tone === "warning"
						? "text-xs text-destructive"
						: "text-xs text-muted-foreground"
				}
			>
				{stage.headline}
			</span>
		</div>
	);
}
